import { render, staticRenderFns } from "./FormDefault.vue?vue&type=template&id=580de1dc&"
import script from "./FormDefault.vue?vue&type=script&lang=ts&setup=true&"
export * from "./FormDefault.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports